export enum AuthApiEnum {
  Auth = 'auth',
  SignIn = 'sign-in',
  SignUp = 'signup',
  SignupVerify = 'signup-verify',
  Invite = 'invite',
  Accept = 'accept',
  Password = 'password',
  Forget = 'forget',
  ForgetVerify = 'forget-verify',
}
